import type { SocialOauthPlatform } from './oauthCallbackMessage';
import { isSocialLinkingPlatform } from './visibleSocialLinkingPlatforms';

export const SOCIAL_OAUTH_RELAY_PATH = '/social-oauth';
export const SOCIAL_OAUTH_WINDOW_NAME = 'autoclipper-social-oauth';
export const SOCIAL_OAUTH_WINDOW_FEATURES = 'width=620,height=760';

export function isSocialOauthRelayPlatform(
  value: unknown,
): value is SocialOauthPlatform {
  return isSocialLinkingPlatform(value);
}

export function buildSocialOauthRelayPath(platform: SocialOauthPlatform): string {
  return `${SOCIAL_OAUTH_RELAY_PATH}?platform=${encodeURIComponent(platform)}`;
}

export function parseSocialOauthRelayPlatform(
  search: string,
): SocialOauthPlatform | null {
  const query = search.startsWith('?') ? search.slice(1) : search;
  const platform = new URLSearchParams(query).get('platform');
  return isSocialOauthRelayPlatform(platform) ? platform : null;
}

export function isSafeAuthorizationUrl(url: unknown): url is string {
  if (typeof url !== 'string' || url.trim() === '') return false;
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
}

export function resolveAuthorizationRedirect(payload: unknown): string | null {
  if (payload === null || typeof payload !== 'object') return null;
  try {
    if (Array.isArray(payload)) return null;
    const descriptor = Object.getOwnPropertyDescriptor(payload, 'authorization_url');
    if (!descriptor || !Object.prototype.hasOwnProperty.call(descriptor, 'value')) {
      return null;
    }
    return isSafeAuthorizationUrl(descriptor.value) ? descriptor.value : null;
  } catch {
    return null;
  }
}

export function replaceCurrentWindow(url: string): void {
  window.location.replace(url);
}
